// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const MIN_LENGTH = 3;
const MAX_LENGTH = 100;
// Malaysian names may contain apostrophes (A'isyah), hyphens (Nur-Ain),
// periods (Dr.) and slashes (A/L, A/P), and may not be padded with spaces.
const MY_NAME_PATTERN = /^[\p{L}](?:[\p{L}\s'./-]*[\p{L}'./-])?$/u;

export function validateMalaysianCustomerName(customerNameValue: string): ?UserInputValidationError {
  const customerName = customerNameValue || '';

  if (!customerName.trim()) {
    return { id: 'empty' };
  }

  if (customerName.length < MIN_LENGTH) {
    return { id: 'min-length' };
  }

  if (customerName.length > MAX_LENGTH) {
    return { id: 'max-length' };
  }

  if (!MY_NAME_PATTERN.test(customerName)) {
    return { id: 'invalid-characters' };
  }
}
